import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import auth from '../components/auth/auth';
import getPermissions from '../components/auth/permissions/getPermissions';

const IdentityContext = React.createContext();

const buildIdentity = () => ({
  isSignedIn: auth.isLoggedIn(),
  profile: auth.getProfile(),
});

const IdentityProvider = props => {
  const { children } = props;
  const [isIdentityInitialized, setIdentityInitialized] = useState(false);
  const [identity, setIdentity] = useState(undefined);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    if (!auth) {
      console.error(
        '[IdentityContext] auth is null/undefined - centralizedAuth failed to initialize'
      );
      return;
    }

    auth.on('authenticated', async () => {
      console.log(
        '[IdentityContext] authenticated event fired, isLoggedIn:',
        auth.isLoggedIn()
      );
      let fetchedPermissions = [];
      try {
        fetchedPermissions = await getPermissions(auth);
      } catch (err) {
        console.error(err);
      }
      setPermissions(fetchedPermissions);
      setIdentity(buildIdentity());
      setIdentityInitialized(true);
    });

    console.log('[IdentityContext] isLoggedIn:', auth.isLoggedIn());
    if (!auth.isLoggedIn()) {
      console.log('[IdentityContext] calling ensureAuthentication');
      auth
        .ensureAuthentication({
          nextUri: window.location.pathname + window.location.search,
        })
        .catch(err => {
          console.error(
            '[IdentityContext] ensureAuthentication failed (stale auth code?), forcing login:',
            err
          );
          // Clear stale ?code=&state= from URL so handleAuthentication won't retry them
          window.history.replaceState({}, '', window.location.pathname);
          auth.login({ forceLogin: true, nextUri: window.location.pathname });
        });
    }
  }, []);

  const identityContextValues = useMemo(
    () => ({
      isIdentityInitialized,
      identity,
      auth,
      permissions,
    }),
    [identity, isIdentityInitialized, permissions]
  );

  return (
    <IdentityContext.Provider value={identityContextValues}>
      {children}
    </IdentityContext.Provider>
  );
};

IdentityProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export { IdentityContext, IdentityProvider };
